import React from 'react';
import { FormattedMessage } from 'react-intl';

import { IconRegularPercent } from '@notino/react-styleguide';

import { trackOnStickyVoucherAnchorClick, useTrackingTiming } from '@services/ecommerceService';
import { ReactFCV } from '@types';
import { EScrollRegistryKeys, triggerRegisteredScroll } from '@utils/scrollRegistry';

import { messages } from './messages';
import { SDiscountCodeAnchor, SDiscountCodeAnchorMessage } from './styled';

export const DiscountCodeAnchor: ReactFCV = () => {
  const getTiming = useTrackingTiming();
  const onClick = (event: React.MouseEvent) => {
    trackOnStickyVoucherAnchorClick(getTiming());
    triggerRegisteredScroll([EScrollRegistryKeys.INPUT_GROUP]);
    event.stopPropagation();
  };
  return (
    <SDiscountCodeAnchor onClick={onClick}>
      <IconRegularPercent color={'icon.primary'} width={`1rem`} height={`1rem`} />
      <SDiscountCodeAnchorMessage>
        <FormattedMessage {...messages.enterVoucherCodeAnchor} />
      </SDiscountCodeAnchorMessage>
    </SDiscountCodeAnchor>
  );
};
